import { useState } from 'react';

type ExpandableCopyProps = {
  text?: string;
  fallback: string;
  maxLength?: number;
};

export function ExpandableCopy({
  text,
  fallback,
  maxLength = 160,
}: ExpandableCopyProps) {
  const [open, setOpen] = useState(false);
  const content = text?.trim() || fallback;
  const isLong = content.length > maxLength;
  const shown =
    open || !isLong ? content : `${content.slice(0, maxLength).trim()}…`;

  /* Modified by: Ishan | Soft-contrast expandable copy and button */
  return (
    <div className="text-left">
      <p className="text-[13px] leading-[1.6] text-[#4A4670] m-0">{shown}</p>
      {isLong ? (
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className="mt-2 cursor-pointer border-none bg-transparent p-0 text-[13px] font-bold text-[#3B66B8] hover:text-[#8156B4] transition"
        >
          {open ? 'Show less' : 'Read more'}
        </button>
      ) : null}
    </div>
  );
}
